const formatAddress = address => {
  if (!address) return null
  return [address.street, address.line2, address.city, address.state, address.zip].filter(Boolean).join(', ')
}

export const placeToAddress = place => {
  const get = type => place.address_components?.find(item => item.types.includes(type))?.short_name ?? ''
  return {
    street: [get('street_number'), get('route')].filter(Boolean).join(' '),
    city: get('locality') || get('sublocality'),
    state: get('administrative_area_level_1'),
    zip: get('postal_code'),
    country: get('country'),
  }
}

export default formatAddress
